export enum MapLocationTags {
  clickLabel = 'Ir a Eventos de Viaje'
}
